import { GtmSetup } from '@/services/gtm/gtm';

function GtmContainer({ children }: React.PropsWithChildren) {
  GtmSetup();

  return children;
}

export default GtmContainer;
